import Vue from 'vue';
import Router from 'vue-router';
//components
import Full from '@/containers/Full';
import Landing from '@/containers/Landing';
import Login from '@/components/Login';
import Users from '@/components/Users';
import AfterAuth from '@/components/AfterAuth';
// beginig of the Dagavor
import ProjectForm from '@/components/dag/ProjectForm'
import ProjectList from '@/components/dag/Projects'
import DpadList2 from '@/components/dag/DpadList2'
import DpadList1 from '@/components/dag/DpadList1'

import HomeMain from '@/components/landing/HomeMain'
import RateInfo from '@/components/landing/RateInfo'
import Reg from '@/components/landing/Reg.vue'
import RLogin from '@/components/landing/RLogin.vue'
import ForgotPassword from '@/components/landing/ForgotPassword.vue'
import Identify from '@/components/landing/Identify.vue'
import BankInfo2 from '@/components/landing/BankInfo2.vue'
import Profile from '@/components/landing/Profile.vue'
import BuyCrypto from '@/components/landing/BuyCrypto.vue';
import MyOrders from '@/components/landing/MyOrders.vue';
import Settings from '@/components/landing/Settings.vue';
import PersonReg from '@/components/landing/PersonReg.vue';
import PersonReg1 from '@/components/landing/PersonReg1.vue';
import OrgReg from '@/components/landing/OrgReg.vue';
import ContentMore from '@/components/landing/ContentMore.vue';
import About from '@/components/landing/About.vue';
import DocList from './components/landing/DocList.vue';
import PdfViewer from './components/landing/PdfViewer.vue';
import Risk from './components/landing/Risk.vue';
import MyProfile from './components/landing/MyProfile.vue';
import Identification from './components/landing/Identification.vue'
import UserTransaction from './components/landing/UserTransaction.vue';
import UserWallet from './components/landing/UserWallet.vue';
import TwoFactor from './components/landing/TwoFactor.vue';
Vue.use(Router);
export default new Router({
   
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            children: [
                {
                    path: '/',
                    name: 'Login1',
                    component: RLogin,
                },
                {
                    path: '/forgot-password',
                    name: 'ForgotPassword',
                    component: ForgotPassword,
                },
                {
                    path: '/reg',
                    name: 'Reg',
                    component: Reg,
                    children:[
                        {
                            path: '/reg/person',
                            name: 'PersonReg',
                            component: PersonReg1,
                        },
                        {
                            path: '/reg/org',
                            name: 'OrgReg',
                            component: OrgReg,
                        }
                    ]
                }

            ]
        },
        {
            path: '/rate',
            name: 'RateInfo',
            component: RateInfo,
           
        },
        
        {
            path: '/afterauth',
            name: 'AfterAuth',
            component: AfterAuth,
        },
        {
            // Mandatory 2FA enrollment, reached only via redirect from
            // RLogin when /syslogin returned requires_2fa_setup=true.
            // No layout / no auth: the page authenticates itself via
            // pre_auth_token stored in localStorage under 'pendingTwoFA'.
            path: '/2fa-setup',
            name: 'TwoFactorSetup',
            component: TwoFactor,
            props: { mode: 'mandatory' },
        },
        {
            path: '/landing',
            name: 'Landing',
            component: Landing,
            children: [
                {
                    path: '/',
                    name: 'HomeMain',
                    component: HomeMain,
                },
                {
                    path: "/contentmore",
                    name: "ContentMore",
                    component:ContentMore,
                },
                {
                    path: "/pdfviewer",
                    name: "PdfViewer",
                    component:PdfViewer,
                },
                {
                    path: "/about",
                    name: "About",
                    component:About,
                },
                {
                    path: "/policy",
                    name: "Policy",
                    component:() => import('./components/landing/Policy.vue'),
                },
                {
                    path: "/terms",
                    name: "Terms",
                    component:() => import('./components/landing/Terms.vue'),
                },
                {
                    path: '/commission',
                    name: 'Commission',
                    component: () => import('./components/landing/Commission.vue'),
                },
                {
                    path: '/risk',
                    name: 'Risk',
                    component: Risk,
                },
                {
                    path: '/doclist',
                    name: 'DocList',
                    component: DocList,
                },
                {
                    path: '/buy/:exType',
                    name: 'BuyCrypto',
                    component: BuyCrypto,
                    children: [

                    ]
                },
                {
                    // Форма покупки выбранного крипто-актива.
                    // Тот же компонент BuyCrypto.vue, но с symbol в URL
                    // — компонент читает $route.params.symbol и показывает
                    // форму вместо списка. Позволяет использовать back
                    // browser button и делиться прямыми ссылками.
                    path: '/buy/:exType/:symbol',
                    name: 'BuyCryptoForm',
                    component: BuyCrypto,
                },
                {
                    path: '/orders',
                    name: 'MyOrders',
                    component: MyOrders,
                    
                },
                {
                    path: '/usertransactions',
                    name: 'UserTransaction',
                    component: UserTransaction,
                },
                {
                    path: '/userwallet',
                    name: 'UserWallet',
                    component: UserWallet,
                },
                {
                    path: '/topup',
                    name: 'TopUp',
                    component: () => import('./components/landing/TopUp.vue'),
                },
                {
                    // Экран ожидания после клика «Купить/Продать» —
                    // показывает order detail + countdown до expires_at.
                    path: '/order/:orderId/wait',
                    name: 'OrderWait',
                    component: () => import('./components/landing/OrderWait.vue'),
                },
                {
                    path:'/digitalwallet',
                    name:'DigitalWallet',
                    component: () => import('./components/landing/DigitalWallet.vue'),
                },
                {
                    path: '/myprofile',
                    name: 'MyProfile',
                    component: MyProfile,
                },
                {
                    path: '/notifications',
                    name: 'Notifications',
                    component: () => import('./components/landing/Notifications.vue'),
                },
                {
                    path: "/identification/:type",
                    name: "Identification",
                    component:Identification
                },
                {
                    path: '/upgradeplan',
                    name: 'UpgradePlan',
                    component: () => import('./components/landing/UpgradePlan.vue'),
                },
                {
                    // New stepper-based wizard: тест → SoF → готово.
                    path: '/qualified',
                    name: 'QualifiedFlow',
                    component: () => import('./components/landing/QualifiedFlow.vue'),
                },
                {
                    // Legacy URL — keep working for existing toasts/cards.
                    // The wizard at /qualified covers the same flow with a
                    // clearer step progression.
                    path: '/qualified-client',
                    redirect: '/qualified',
                },
                {
                    // Stepper-based wizard mirroring /qualified for the
                    // Professional Client path (test → history → SoF/SoW
                    // → certs → consents → status).
                    path: '/professional',
                    name: 'ProfessionalFlow',
                    component: () => import('./components/landing/ProfessionalFlow.vue'),
                },

                {
                    path: '/bankinfo',
                    name: 'BankInfo2',
                    component: BankInfo2,
                },
                {
                    // Stand-alone /security — TwoFactor.vue is self-contained
                    // and shouldn't inherit the Settings page chrome (cover
                    // photo + avatar pencil) that /identify and /profile use.
                    path: '/security',
                    name: 'Security',
                    component: TwoFactor,
                    props: { mode: 'settings' },
                },
                {
                    path: '/settings',
                    name: 'Settings',
                    component: Settings,
                    children:[
                        {
                            path: '/identify',
                            name: 'Identify',
                            component: Identify,
                        },
                        {
                            path: '/profile',
                            name: 'Profile',
                            component: Profile,
                        }
                    ]
                }

            ]
        },
        {
            path: '/',
            redirect: '/landing',
            component: Full,
            children: [
                {
                    path: '/users',
                    name: 'Users',
                    component: Users,
                    meta:{requiresAuth:true}
                },

                {
                    path: '/addproject',
                    name: 'AddProject',
                    component: ProjectForm,
                    meta:{requiresAuth:true}
                },
                {
                    path: '/projectlist',
                    name: 'ProjectList',
                    component: ProjectList,
                    meta:{requiresAuth:true}
                },
                {
                    path: '/dpadlist1',
                    name: 'DpadList1',
                    component: DpadList1,
                    meta:{requiresAuth:true}
                },
                {
                    path: '/dpadlist2',
                    name: 'DpadList2',
                    component: DpadList2,
                    meta:{requiresAuth:true}
                },
            ]
        }
    ]
})